import type {Worker} from "./types";
import {StatusBadge} from "./components/ui";
import {useI18n} from "./i18n";

export function WorkerAvailability({worker}:{worker:Worker}) {
 const {t}=useI18n();
 const intake=worker.intake_enabled??Boolean(worker.enabled);
 return <><StatusBadge value={!intake?"intake-paused":(worker.accepting_tasks??Boolean(worker.effective_enabled))?"accepting-tasks":"intake-unavailable"}/>
  <small>{t(worker.execution_enabled?"Existing tasks can execute":"Execution is unavailable")}</small>
  <small>{t(worker.availability_reason||"runtime_status_unknown")}</small>
  {worker.runtime_capacity!==undefined&&<small>{t("Worker capacity")}: {worker.runtime_capacity}</small>}
 </>;
}
